import React, {FunctionComponent, useContext} from 'react';
import {User} from '/src/domain/shared/User';
import {Collapse, Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {trimName} from "/src/domain/shared/trimName";
import {ChallengeContext, ChallengeContextProps} from "/src/contexts/ChallengeContext";
import AuditTrack from "/src/ui/challengeProtocol/audit/AuditTrack";
import EmptyAuditBanner from "/src/ui/challengeProtocol/audit/EmptyAuditBanner";

interface AuditResultProps {
    currentUser: User;
    challengeKey: string;
  }
  

const AuditResult: FunctionComponent<AuditResultProps> = ({
    currentUser,
    challengeKey,
}) => {

    const {t} = useTranslation()
    const classes = useStyles();
    const {error, currentAudit} = useContext(ChallengeContext) as ChallengeContextProps;

    return <>
        <Collapse in={Boolean(error)}>
            <div className={classes.userData}>
                {t(error as string)}
            </div>
        </Collapse>
        <Collapse in={Boolean(currentAudit)}>
            {Boolean(currentAudit) &&
                <>
                    <div className={classes.userData}>
                        {
                            currentAudit?.userinfo &&
                            <span>{trimName(currentAudit?.userinfo.firstname, currentAudit?.userinfo.lastname)}</span>
                        }
                        <span>{currentAudit?.isRegistered ? t('registered') : t('notRegistered')}</span>
                    </div>
                    {
                        currentAudit?.isRegistered &&
                        <>
                            {
                                currentAudit?.audit && currentAudit?.audit.length > 0 &&
                                <Grid container
                                      alignItems="center"
                                      justifyContent="center"
                                      className={classes.header}
                                      spacing={1}
                                >
                                    <Grid item xs={1} className={classes.headerCell}/>
                                    <Grid item xs={4} className={classes.headerCell}>{t('activityStart')}</Grid>
                                    <Grid item xs={6} className={classes.headerCell}>{t('status')}</Grid>
                                </Grid>
                            }
                            {currentAudit?.audit.map(t => 
                                <AuditTrack 
                                    key={t.id} 
                                    track={t}
                                    challengeKey={challengeKey}
                                    currentUser={currentUser}
                                    />)}
                            {!currentAudit?.audit.length && <EmptyAuditBanner/>}
                        </>
                    }
                </>
            }
        </Collapse>
    </>;
}

const useStyles = makeStyles({
    userData: {
        padding: '0.5rem 1.5rem 0',
        display: 'flex',
        flexDirection: 'column',
        '&>span': {
            padding: '0.2rem 0'
        }
    },
    header: {
        width: '100%',
        padding: '0.5rem 0',
        margin: 0,
        fontSize: '0.9rem',
        fontWeight: 600,
    },
    headerCell: {
        overflowX: 'auto'
    }
})

export default AuditResult